import React, { useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import "./CreateVoucherAndCouponsInputs.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datepickericon from "../../assets/date-picker.svg";
import { Image } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import iicon from "../../assets/i.svg";
import ImageUploadCrop from "../ImageUpload/ImageUploadCrop";

const CreateVoucherInputs = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDate, setAvailableDate] = useState(null);
  const [visibleDate, setVisibleDate] = useState(null);

  // console.log(props.errorLabelvalue, "xyz");

  const [data, setData] = useState({
    voucher_name: "",
    voucher_price: "",
    voucher_limit: "",
    voucher_value: "",
    description: "",
  });

  const handleChange = (e, flag) => {
    // if (flag === "voucher_value") {
    //   setData((ps) => {
    //     const inputValue = e.target.value;
    //     if (inputValue === "" || isNaN(parseFloat(inputValue))) {
    //       return {
    //         ...ps,
    //         voucher_value: "",
    //       };
    //     }
    //     return {
    //       ...ps,
    //       voucher_value:
    //         inputValue.length <= 10
    //           ? parseInt(inputValue) < 0
    //             ? 0
    //             : parseInt(inputValue)
    //           : parseFloat(inputValue.slice(0, 10)),
    //     };
    //   });
    // }
    if (flag === "voucher_value") {
      setData((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 10);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }
        return {
          ...ps,
          voucher_value: finalNumber,
        };
      });
    }
    // else if (flag === "voucher_price") {
    //   setData((ps) => {
    //     const inputValue = e.target.value;
    //     if (inputValue === "" || isNaN(parseFloat(inputValue))) {
    //       return {
    //         ...ps,
    //         voucher_price: "",
    //       };
    //     }
    //     return {
    //       ...ps,
    //       voucher_price:
    //         e.target.value.length <= 10
    //           ? parseInt(e.target.value) < 0
    //             ? 0
    //             : parseInt(e.target.value)
    //           : parseFloat(e.target.value.slice(0, 10)),
    //     };
    //   });
    // }
    else if (flag === "voucher_price") {
      setData((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 10);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }
        return {
          ...ps,
          voucher_price: finalNumber,
        };
      });
    } else if (flag === "voucher_limit") {
      setData((ps) => {
        const inputValue = e.target.value;
        if (inputValue === "" || isNaN(parseFloat(inputValue))) {
          return {
            ...ps,
            voucher_limit: "",
          };
        }
        return {
          ...ps,
          voucher_limit:
            e.target.value.length <= 3
              ? parseInt(e.target.value) < 0
                ? 0
                : parseInt(e.target.value)
              : parseFloat(e.target.value.slice(0, 3)),
        };
      });
    } else if (flag === "voucher_name") {
      setData((ps) => {
        return {
          ...ps,
          voucher_name: e.target.value,
        };
      });
    }
  };

  const handleStart = (e) => {
    setStartDate(e);
    props.setErrorLabelstart("");
  };
  const handleEnd = (e) => {
    setEndDate(e);
    props.setErrorLabelend("");
  };
  const handleAvailableDate = (e) => {
    setAvailableDate(e);
    props.setErrorLabelAvailableDate("");
  };

  props.func(data, startDate, endDate, availableDate, visibleDate); //pass
  return (
    <div className="input_fileds">
      <Form className="formmain mx-2 mt-2 signin-row profile-form pb-4 Create-Vouch">
        <Row>
          <Col md="12">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Voucher Name <span className="star-required">*</span>
              </Form.Label>
              <InputGroup className="edit-border">
                <Form.Control
                  style={{ width: "100%" }}
                  type="text"
                  value={data.voucher_name}
                  placeholder="Voucher Name"
                  className="custom-formcontrol"
                  maxLength={200}
                  name="voucher_name"
                  onChange={(e) => handleChange(e, "voucher_name")}
                  autoComplete="off"
                />
              </InputGroup>
              <ErrorLabel ErrorDisplay={props.errorLabelname} />
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex gap-30 mb-3 img_sec_product">
          <div className="col-4 px-0 mb-2">
            <ImageUploadCrop
              imgType="logo_img"
              aspect={1 / 1}
              recommendedSize="1000px x 1000px"
              label="Voucher"
              croppedImage={props.logoImage}
              setCroppedImage={props.setLogoImage}
            />
            <ErrorLabel ErrorDisplay={props.errorLogoImage} />
          </div>
          <div className="col-8 px-0">
            <ImageUploadCrop
              imgType="fb_img"
              aspect={1.91 / 1}
              recommendedSize="1200px x 630px"
              label="Social Share"
              croppedImage={props.fbImage}
              setCroppedImage={props.setFbImage}
            />
            <ErrorLabel ErrorDisplay={props.errorFbImage} />
          </div>
        </div>

        <Row className="VoucherAmountDollar">
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <div>
                  <p className="VoucherP VLimit">Voucher</p>
                  <p>
                    Limit
                    <span className="star-required">
                      *
                      {["top"].map((placement) => (
                        <OverlayTrigger
                          // trigger={"click"}
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip
                              id={`tooltip-${placement}`}
                              style={{ width: "50%" }}
                            >
                              This field indicates quantity of the voucher. (ex:
                              if you are entering 10 as voucher limit it will
                              allow only 10 vouchers to be created)
                            </Tooltip>
                          }
                        >
                          <Image
                            loading="lazy"
                            src={iicon}
                            className="mb-1"
                            width="15px"
                          ></Image>
                        </OverlayTrigger>
                      ))}
                    </span>
                  </p>
                </div>
              </Form.Label>
              <p className="info-text-space">
                &#40;One Voucher Per Transaction&#41;
              </p>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <Form.Control
                    // style={{ width: "200px" }}
                    type="text"
                    value={data.voucher_limit}
                    placeholder="Voucher Limit"
                    className="custom-formcontrol"
                    maxLength={3}
                    name="voucher_limit"
                    onChange={(e) => handleChange(e, "voucher_limit")}
                    autoComplete="off"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabellimit} />
              </div>
            </Form.Group>
          </Col>
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <div>
                  <p className="VoucherP VValue">Voucher Retail</p>
                  <p>
                    Value($)
                    <span className="star-required">
                      *
                      {["top"].map((placement) => (
                        <OverlayTrigger
                          // trigger={"click"}
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip
                              id={`tooltip-${placement}`}
                              style={{ width: "50%" }}
                            >
                              This is the actual price of the voucher. Enter
                              numeric values only.
                            </Tooltip>
                          }
                        >
                          <Image
                            loading="lazy"
                            src={iicon}
                            className="mb-1"
                            width="15px"
                          ></Image>
                        </OverlayTrigger>
                      ))}
                    </span>
                  </p>
                </div>
              </Form.Label>
              <p className="info-text-space">&#40;Value cannot be zero&#41;</p>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <Form.Control
                    placeholder="Voucher Retail Value"
                    className="custom-formcontrol"
                    value={data.voucher_value}
                    maxLength={10}
                    name="voucher_value"
                    onChange={(e) => handleChange(e, "voucher_value")}
                    autoComplete="off"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelvalue} />
              </div>
            </Form.Group>
          </Col>
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <div>
                  <p className="VoucherP VDiscount">Voucher Discounted </p>
                  <p>
                    Price($)
                    <span className="star-required">
                      *{" "}
                      {["top"].map((placement) => (
                        <OverlayTrigger
                          // trigger={"click"}
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip
                              id={`tooltip-${placement}`}
                              style={{ width: "fit-content" }}
                            >
                              This is the discounted price of the voucher. Enter
                              numeric values only.
                            </Tooltip>
                          }
                        >
                          <Image
                            loading="lazy"
                            src={iicon}
                            className="mb-1"
                            width="15px"
                          ></Image>
                        </OverlayTrigger>
                      ))}
                    </span>
                  </p>
                </div>
              </Form.Label>
              <p className="info-text-space">&#40;Value cannot be zero&#41;</p>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <Form.Control
                    // style={{ width: "200px" }}

                    placeholder="Voucher Discounted Price"
                    className="custom-formcontrol"
                    maxLength={10}
                    name="voucher_price"
                    onChange={(e) => handleChange(e, "voucher_price")}
                    value={data.voucher_price}
                    autoComplete="off"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelprice} />
              </div>
            </Form.Group>
          </Col>
        </Row>
        {/* ss */}
        <Row className="VoucherAmountDollar">
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <p className="VoucherP VLimit">
                  Voucher Publish Start Date
                  <span className="star-required">*</span>
                </p>
              </Form.Label>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={startDate}
                    className="custom-formcontrol"
                    onChange={handleStart}
                    minDate={new Date()}
                    maxDate={
                      availableDate !== ""
                        ? availableDate
                        : endDate !== ""
                        ? endDate
                        : endDate
                    }
                    placeholderText="Publish Start Date"
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                    onChange={handleStart}
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelstart} />
              </div>
            </Form.Group>
          </Col>
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <p className="VoucherP VValue">
                  Voucher Available Until Date
                  <span className="star-required">*</span>
                </p>
              </Form.Label>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={availableDate}
                    className="custom-formcontrol"
                    onChange={handleAvailableDate}
                    minDate={
                      startDate !== ""
                        ? startDate
                        : availableDate === ""
                        ? new Date()
                        : new Date()
                    }
                    maxDate={endDate}
                    placeholderText="Available Until Date"
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelAvailableDate} />
              </div>
            </Form.Group>
          </Col>
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                <p className="VoucherP VDiscount">
                  Voucher Expiration Date
                  <span className="star-required">*</span>
                </p>
              </Form.Label>
              <div className="editInputDiv">
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={endDate}
                    className="custom-formcontrol"
                    onChange={handleEnd}
                    minDate={
                      availableDate !== "" && availableDate > startDate
                        ? availableDate
                        : startDate !== ""
                        ? startDate
                        : new Date()
                    }
                    placeholderText="Expiration Date"
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelend} />
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* eee */}
      </Form>
    </div>
  );
};

export default CreateVoucherInputs;
